const orientation = {
  gamma: {
    onIncrease: null,
    onDecrease: null
  },

  alpha: {
    onIncrease: null,
    onDecrease: null
  },

  beta: {
    onIncrease: null,
    onDecrease: null
  }
}

window.addEventListener('deviceorientation', event => {
  if (event.gamma > 0 && orientation.gamma.onIncrease) {
    orientation.gamma.onIncrease(event.gamma)
  }

  if (event.gamma < 0 && orientation.gamma.onDecrease) {
    orientation.gamma.onDecrease(event.gamma)
  }

  if (event.alpha > 0 && orientation.alpha.onIncrease) {
    orientation.alpha.onIncrease(event.alpha)
  }

  if (event.alpha < 0 && orientation.alpha.onDecrease) {
    orientation.alpha.onDecrease(event.alpha)
  }

  if (event.beta > 0 && orientation.beta.onIncrease) {
    orientation.beta.onIncrease(event.beta)
  }

  if (event.beta < 0 && orientation.beta.onDecrease) {
    orientation.beta.onDecrease(event.beta)
  }

  event.preventDefault()
}, false)

export default orientation
